import {
  AG_GRID_LOCALE_BG,
  AG_GRID_LOCALE_DE,
  AG_GRID_LOCALE_DK,
  AG_GRID_LOCALE_EN,
  AG_GRID_LOCALE_ES,
  AG_GRID_LOCALE_FI,
  AG_GRID_LOCALE_FR,
  AG_GRID_LOCALE_IT,
  AG_GRID_LOCALE_PL,
  AG_GRID_LOCALE_PT,
  AG_GRID_LOCALE_RO,
  AG_GRID_LOCALE_SK,
  AG_GRID_LOCALE_TR,
  AG_GRID_LOCALE_VN,
} from "@ag-grid-community/locale";

import { useLocale } from "./locale";
import { useMantineColorScheme, useMantineTheme } from "@mantine/core";
import type { ThemeDefaultParams } from "ag-grid-community";
import { themeQuartz } from "ag-grid-community";
import { useMemo } from "react";

const agGridLocalization: Record<string, Record<string, string>> = {
  es: AG_GRID_LOCALE_ES,
  en: AG_GRID_LOCALE_EN,
  fr: AG_GRID_LOCALE_FR,
  de: AG_GRID_LOCALE_DE,
  it: AG_GRID_LOCALE_IT,
  pt: AG_GRID_LOCALE_PT,
  tr: AG_GRID_LOCALE_TR,
  da: AG_GRID_LOCALE_DK,
  pl: AG_GRID_LOCALE_PL,
  bg: AG_GRID_LOCALE_BG,
  fi: AG_GRID_LOCALE_FI,
  ro: AG_GRID_LOCALE_RO,
  sk: AG_GRID_LOCALE_SK,
  vi: AG_GRID_LOCALE_VN,
};

export const useAgGridLocale = () => {
  const locale = useLocale();

  return agGridLocalization[locale] ?? AG_GRID_LOCALE_EN;
};

export const useAgGridTheme = () => {
  const { colorScheme } = useMantineColorScheme();
  const { colors } = useMantineTheme();

  const light: Partial<ThemeDefaultParams> = {
    accentColor: colors.orange[9],
    borderColor: "#000",
    borderRadius: 8,
    browserColorScheme: "light",
    cellTextColor: "#000",
    fontFamily: {
      googleFont: "Geist",
    },
    borderWidth: 2,
    headerBackgroundColor: colors.gray[1],
    headerFontSize: 14,
    headerFontWeight: 600,
    textColor: "#000",
    headerTextColor: "#000",
    wrapperBorderRadius: 12,
  };

  const dark: Partial<ThemeDefaultParams> = {
    accentColor: colors.orange[9],
    backgroundColor: "#000",
    borderColor: "#FFF",
    borderRadius: 8,
    borderWidth: 2,
    browserColorScheme: "dark",
    cellTextColor: "#FFF",
    textColor: "#FFF",
    fontFamily: {
      googleFont: "Geist",
    },

    headerBackgroundColor: colors.gray[8],
    headerFontSize: 14,
    headerFontWeight: 600,
    headerTextColor: "#FFF",
    wrapperBorderRadius: 12,
  };

  return useMemo(() => {
    return themeQuartz
      .withParams(colorScheme == "dark" ? dark : light);
  }, [colorScheme]);
};
